import { Injectable, NgZone } from '@angular/core';
import { ReplaySubject, Observable, Subscriber } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AmapPluginLoaderService } from '../../shared/amap-plugin-loader.service';
import { EventBinderService } from '../../shared/event-binder.service';
import { LoggerService } from '../../shared/logger/logger.service';
import { Getter } from '../../base/interfaces';
declare const AMap: any;

const TAG = 'AmapAutocomplete';

export namespace AMapAutocomplete {
  export type DataType = 'all' | 'bus' | 'poi' | 'busline';
  export interface Options {
    /**
     * è¾å¥æç¤ºæ¶éå®POIç±»åï¼å¤ä¸ªç±»åç¨â|âåé
     */
    type?: string;
    /**
     * è¾å¥æç¤ºæ¶éå®åå¸
     */
    city?: string;
    /**
     * è¿åçæ°æ®ç±»å
     */
    datatype?: DataType;
    /**
     * æ¯å¦å¼ºå¶éå¶å¨è®¾ç½®çåå¸åæç´¢
     */
    citylimit?: boolean;
    /**
     * æå®è¾å¥æ¡
     */
    input?: string | HTMLInputElement;
    /**
     * æå®è¾åºé¢æ¿
     */
    output?: string | HTMLDivElement;
    /**
     * æ¯å¦å¨inputä½äºé¡µé¢è¾ä¸æ¹çæ¶åèªå¨å°è¾å¥é¢æ¿æ¾ç¤ºå¨inputä¸æ¹ä»¥é¿åè¢«é®æ¡
     */
    outPutDirAuto?: boolean;
  }
  export interface Tip {
    /**
     * åç§°
     */
    name: string;
    /**
     * æå±åºå
     */
    district: string;
    /**
     * åºåç¼ç 
     */
    adcode: string;
    /**
     * å°å
     */
    address: string;
    /**
     * åå¸
     */
    city: any[];
    /**
     * ID
     */
    id: string;
    /**
     * åæ ç»çº¬åº¦
     */
    location: AMap.LngLat;
    /**
     * ç±»åç¼ç 
     */
    typecode: string;
  }
  export interface SearchResult {
    /**
     * æ¥è¯¢ç¶æè¯´æ
     */
    info: string;
    /**
     * è¾å¥æç¤ºæ¡æ°
     */
    count: number;
    /**
     * è¾å¥æç¤ºåè¡¨
     */
    tips: Tip[];
  }
  export type SearchStatus = 'complete' | 'error' | 'no_data';
}

export interface AutocompleteSearchResult {
  status: AMapAutocomplete.SearchStatus;
  result: string | AMapAutocomplete.SearchResult;
}

@Injectable({
  providedIn: 'root',
})
export class AmapAutocompleteService implements Getter<any> {
  private ac: any;
  private ac$ = new ReplaySubject<any>(1);

  constructor(
    private plugin: AmapPluginLoaderService,
    private binder: EventBinderService,
    private logger: LoggerService,
    private ngZone: NgZone,
  ) {}

  /**
   * è·åæä»¶
   */
  get() {
    return this.ac$.asObservable();
  }

  /**
   * ä¾¦å¬äºä»¶
   */
  on(event: string) {
    return this.binder.bindEvent(this.get(), event);
  }

  /**
   * åå»ºæä»¶
   */
  create(options: AMapAutocomplete.Options) {
    return this.plugin.load('AMap.Autocomplete').pipe(
      map(() => {
        this.ac = this.ngZone.runOutsideAngular(() => new AMap.Autocomplete(options));
        this.logger.d(TAG, 'new autocomplete created.');
        this.ac$.next(this.ac);
        this.ac$.complete();
        return this.ac;
      }),
    );
  }

  /**
   * æç´¢
   */
  search(address: string) {
    return this.get().pipe(
      switchMap(
        ac =>
          new Observable((observer: Subscriber<AutocompleteSearchResult>) => {
            ac.search(address, (status, result) => {
              observer.next({ status, result });
              observer.complete();
            });
          }),
      ),
    );
  }
}
